import {
    Card,
    RadioButton,
    Colors,
    Text,
    type CustomRadioOptionProps,
    defaultHover,
} from '@amelio/ui-library';

import type { ReactNode } from 'react';

interface RadioCardProps extends CustomRadioOptionProps {
    description: string;
    className?: string;
    icon?: ReactNode;
}

export const RadioCard = ({
    option,
    isChecked,
    name,
    description,
    onSelect,
    className,
    icon,
}: RadioCardProps) => {
    const descriptionId = `${name}-${option.value}-description`;

    return (
        <Card
            bgColor={'bg-white'}
            borderColor={isChecked ? Colors.PRIMARY : Colors.BASE_50}
            className={`${defaultHover} ${className || ''}`}
            onClick={onSelect}
        >
            <div className={'flex flex-row'}>
                <RadioButton
                    label={''}
                    ariaLabel={option.label}
                    ariaDescribedBy={descriptionId}
                    name={name}
                    checkedColorClassName={'bg-primary'}
                    value={option.value}
                    borderColorClassName={`${isChecked ? 'border-primary' : 'border-base-300'}`}
                    checked={isChecked}
                    onChange={onSelect}
                />

                <div className={'-mt-0.5 flex flex-col'}>
                    <div className={'flex flex-row items-center gap-2'}>
                        {icon}

                        <Text weight={'semibold'}>{option.label}</Text>
                    </div>

                    <Text
                        id={descriptionId}
                        color={Colors.BASE_400}
                        size={'small'}
                        className={'mt-1'}
                    >
                        {description}
                    </Text>
                </div>
            </div>
        </Card>
    );
};
